import Vue from 'vue';
import { ConstantUtil } from '@/utils/ConstantUtil';
import * as types from './mutation-types';

const deepcopy = require('deepcopy');

const selectAccount = (state, currIndex) => {
    state.currAccountIndex = currIndex;
    localStorage.setItem('j-currAccountIndex', currIndex);
};
const mutations = {
    [types.ADD_ACCOUNT](state, account) {
        if (!state.accountList) {
            state.accountList = [];
        }
        state.accountList = deepcopy([...state.accountList, account]);
        localStorage.setItem('j-accountList', JSON.stringify(state.accountList));
        if (state.accountList.length === 1) {
            selectAccount(state, 0);
        }
    },
    [types.LOGOUT](state) {
        state.user = {};
    },
    [types.CHANGE_INVITER_NOT_EXIST](state, value) {
        state.inviterNotExist = value;
    },
    [types.LOGIN](state, data) {
        state.user = data;
    },
    // 修改
    [types.EDIT_ACCOUNT](state, account) {
        state.accountList = state.accountList.map((acc) => {
            let accInfo = acc;
            if (accInfo.userid === account.userid) {
                accInfo = account;
            }
            return accInfo;
        });
        localStorage.setItem('j-accountList', JSON.stringify(state.accountList));
    },
    [types.EDIT_INTRO_ORDER](state, value) {
        state.introOrder = value;
    },
    [types.EDIT_INTRO_USER](state, value) {
        state.introUser = value;
    },
    [types.SET_ACCOUNT_LIST](state, accountList) {
        state.accountList = accountList;
        localStorage.setItem('j-accountList', JSON.stringify(state.accountList));
    },
    [types.SELECT_ACCOUNT](state, currIndex) {
        selectAccount(state, currIndex);
    },
    [types.CHANGE_CREATE_ACCOUNT_STATUS](state, isShow) {
        state.isShowGenerate = isShow;
    },
    [types.CHANGE_CONFIRMSTATUS](state, zindex) {
        state.confirmStatus = zindex;
    },
    SOCKET_ONOPEN(state, event) {
        Vue.prototype.$socket = event.currentTarget;
        state.socket.isConnected = true;
    },
    SOCKET_ONCLOSE(state) {
        state.socket.close = true;
    },
    SOCKET_ONERROR(state, event) {
        state.socket.error = true;
        console.error(state, event);
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE(state, message) {
        state.socket.message = message;
        const dataType = message.method;
        const id = message.id;
        if (id) {
            if (id === ConstantUtil.webSocket.sign.code) {
                if (message.result && message.result.status === 'success') {
                    state.signStatus += 1;
                }
            }

            if (id === ConstantUtil.webSocket.assetQuery.code) {
                if (message.error === null) {
                    state.assetQueryStatus += 1;
                    state.balances = Object.values(message.result);
                }
            }
            if (id === ConstantUtil.webSocket.asset.code) {
                if (message.error === null) {
                    state.assetWebScokcetStatus += 1;
                }
            }
            if (id === ConstantUtil.webSocket.cancelDeals.code) {
                if (message.error === null) {
                    state.cancelDealStatus += 1;
                }
            }
            if (id === ConstantUtil.webSocket.cancelDepth.code) {
                if (message.error === null) {
                    state.cancelDepthStatus += 1;
                }
            }
            if (id === ConstantUtil.webSocket.order.code) {
                if (message.error === null) {
                    state.orderWebSocketStatus += 1;
                }
            }
            if (id === ConstantUtil.webSocket.cancelAsset.code) {
                if (message.error === null) {
                    state.cancelAssetWebSocketStatus += 1;
                }
            }
            if (id === ConstantUtil.webSocket.deals.code) {
                if (message.error === null) {
                    state.dealWebSocketStatus += 1;
                }
            }
            if (id === ConstantUtil.webSocket.today.code) {
                if (message.error === null) {
                    state.todayWebSocketStatus += 1;
                }
            }
            if (id === ConstantUtil.webSocket.depth.code) {
                if (message.error === null) {
                    state.depthWebSocketStatus += 1;
                }
            }
            if (id === ConstantUtil.webSocket.cash.code) {
                if (message.error === null) {
                    state.cashWebSocketStatus += 1;
                }
            }
        } else if (dataType === 'today.update') {
            state.newMarketData = message.params;
        } else if (dataType === 'deals.update') {
            state.newDeal = message.params;
        } else if (dataType === 'depth.update') {
            state.newDepth = message.params;
        } else if (dataType === 'order.update') {
            console.log('order.update');
            state.newOrder = message.params;
        } else if (dataType === 'cash.update') {
            const priceUSD = {};
            const priceCNY = {};
            for (let i = 0; i < message.params.length; i += 1) {
                for (let k = 0; k < message.params[i].currency.length; k += 1) {
                    if (message.params[i].currency[k] && message.params[i].currency[k].currency === 'USD' && message.params[i].currency[k].price) {
                        priceUSD[message.params[i].symbol] = message.params[i].currency[k].price;
                    }
                    if (message.params[i].currency[k] && message.params[i].currency[k].currency === 'CNY' && message.params[i].currency[k].price) {
                        priceCNY[message.params[i].symbol] = message.params[i].currency[k].price;
                    }
                }
            }
            state.priceUSD = priceUSD;
            state.priceCNY = priceCNY;
        } else if (dataType === 'asset.update') {
            console.log('asset.update');
            const balances = deepcopy(state.balances);
            const assets = Object.keys(message.params[0]);
            assets.forEach((assetId) => {
                for (let i = 0; i < balances.length; i += 1) {
                    if (balances[i].id == assetId) {
                        balances[i].available = message.params[0][assetId][0];
                    }
                }
            });
            state.balances = balances;
        }
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT(state, count) {
        console.info(state, count);
    },
    SOCKET_RECONNECT_ERROR(state) {
        state.socket.reconnectError = true;
    },
};
export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js